import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICards = ({ data, loading }) => {
  const mockData = {
    totalCost: 4390000,
    totalInstallations: 156,
    avgROI: 9.2,
    completionRate: 92.3,
    activeBrands: 12,
    activeStores: 8,
    monthlyGrowth: 15.8,
    avgCostPerInstall: 28141
  };

  const kpiData = data || mockData;

  const formatCurrency = (value) => {
    if (value >= 100000) {
      return `৳${(value / 100000)?.toFixed(1)}L`;
    }
    return `৳${(value / 1000)?.toFixed(0)}K`;
  };

  const kpiCards = [
    {
      title: 'Total Investment',
      value: formatCurrency(kpiData?.totalCost),
      change: '+12.5%',
      changeType: 'positive',
      icon: 'DollarSign',
      description: 'Total branding costs across all stores'
    },
    {
      title: 'Total Installations',
      value: kpiData?.totalInstallations?.toString(),
      change: '+8 this month',
      changeType: 'positive',
      icon: 'Package',
      description: 'Completed branding installations'
    },
    {
      title: 'Average ROI',
      value: `${kpiData?.avgROI}%`,
      change: '+1.2%',
      changeType: 'positive',
      icon: 'TrendingUp',
      description: 'Return on investment across brands'
    },
    {
      title: 'Completion Rate',
      value: `${kpiData?.completionRate}%`,
      change: '-2.1%',
      changeType: 'negative',
      icon: 'CheckCircle',
      description: 'Installation completion percentage'
    },
    {
      title: 'Active Brands',
      value: kpiData?.activeBrands?.toString(),
      change: '+2 new',
      changeType: 'positive',
      icon: 'Tag',
      description: 'Brands with active installations'
    },
    {
      title: 'Active Stores',
      value: kpiData?.activeStores?.toString(),
      change: 'No change',
      changeType: 'neutral',
      icon: 'Store',
      description: 'Stores with branding activities'
    },
    {
      title: 'Monthly Growth',
      value: `${kpiData?.monthlyGrowth}%`,
      change: '+3.2%',
      changeType: 'positive',
      icon: 'BarChart3',
      description: 'Month-over-month cost growth'
    },
    {
      title: 'Avg Cost/Install',
      value: formatCurrency(kpiData?.avgCostPerInstall),
      change: '-5.8%',
      changeType: 'positive',
      icon: 'Calculator',
      description: 'Average cost per installation'
    }
  ];

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success';
      case 'negative':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const getChangeIcon = (type) => {
    switch (type) {
      case 'positive':
        return 'TrendingUp';
      case 'negative':
        return 'TrendingDown';
      default:
        return 'Minus';
    }
  };

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        {Array.from({ length: 8 })?.map((_, index) => (
          <div key={index} className="bg-surface border border-border rounded-lg p-6">
            <div className="animate-pulse">
              <div className="flex items-center justify-between mb-4">
                <div className="w-8 h-8 bg-muted rounded-lg" />
                <div className="w-16 h-4 bg-muted rounded" />
              </div>
              <div className="w-20 h-8 bg-muted rounded mb-2" />
              <div className="w-full h-3 bg-muted rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {kpiCards?.map((card, index) => (
        <div key={index} className="bg-surface border border-border rounded-lg p-6 hover:shadow-elevated transition-shadow duration-200">
          <div className="flex items-center justify-between mb-4">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={card?.icon} size={20} className="text-primary" />
            </div>
            <div className={`flex items-center gap-1 text-xs font-medium ${getChangeColor(card?.changeType)}`}>
              <Icon name={getChangeIcon(card?.changeType)} size={12} />
              {card?.change}
            </div>
          </div>
          
          <div className="space-y-2">
            <div className="text-2xl font-bold text-foreground">{card?.value}</div>
            <div className="text-sm font-medium text-foreground">{card?.title}</div>
            <div className="text-xs text-muted-foreground leading-relaxed">{card?.description}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KPICards;